import { Pipe, PipeTransform } from '@angular/core';

/*
 * Return object keys as array of strings
 * Takes an object as argument
 * Usage:
 *   object | keys
 * Example:
 *   {{ { a: 4, b:6 } | keys }}
 *   formats to: ['a', 'b']
 */
@Pipe({ name: 'laKeys' })
export class KeysPipe implements PipeTransform {
  transform<T extends object>(value: T): string[] {
    return Object.keys(value);
  }
}
